import ProductPage from "./product-page";
import ProductSubPage from "./sub-page";

const Product = {
    Page : ProductPage,
    SubPage : ProductSubPage
};

export default Product;